import React from "react";
import "./ArticleCard.css";
function ArticleCard({ title, imgSrc, link }) {
  return (
    <div className="articleCard">
      <a target="_blank" href={link}>
        <img src={imgSrc} />
        <h3>{title}</h3>
        <p>Click to Read full article on Medium make sure to like it</p>
      </a>
    </div>
  );
}

export default ArticleCard;
